<div class="container">

  <!-- FlashPay: Upload vs Manual toggle -->
  <div
    class="invoice-mode-toggle"
    *ngIf="isFlashPayView && enableInvoiceUpload && !isMultiInvoiceMode"
  >
    <mat-button-toggle-group [(ngModel)]="invoiceInputMode">
      <mat-button-toggle value="upload">
        <mat-icon>upload_file</mat-icon>
        Upload invoice
      </mat-button-toggle>
      <mat-button-toggle value="manual">
        <mat-icon>edit</mat-icon>
        Enter manually
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <!-- Upload Mode: show InvoiceUploadComponent -->
  <div *ngIf="isFlashPayView && enableInvoiceUpload && invoiceInputMode === 'upload' && !isMultiInvoiceMode" class="invoice-upload-wrapper">
    <app-invoice-upload
      [isParsing]="isParsingInvoices"
      [parseStatuses]="invoiceParseStatuses"
      [parseFailed]="invoiceParseFailed"
      (filesChanged)="onInvoiceFilesChanged($event)"
      (retryParse)="onInvoiceFilesChanged($event)"
    ></app-invoice-upload>
  </div>

  <!-- Mode Toggle (only show if invoice feature enabled and not in special views) -->
  <div
    class="invoice-mode-toggle"
    *ngIf="isInvoiceFeatureEnabled && isAdhocInvoiceAllowed && !isCompleteAuthView && !isRefundView && !isAdjustView && view !== 'flashpay'"
  >
    <mat-button-toggle-group [(ngModel)]="isMultiInvoiceMode" (change)="toggleInvoiceMode()">
      <mat-button-toggle [value]="false">
        <mat-icon>receipt</mat-icon>
        Single Invoice
      </mat-button-toggle>
      <mat-button-toggle [value]="true">
        <mat-icon>receipt_long</mat-icon>
        Multiple Invoices
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <!-- Single Invoice Form (existing) -->
  <div class="single-invoice-form" *ngIf="!isMultiInvoiceMode" [formGroup]="form">
    <div class="row">
      <div class="col-4">
        <fieldset>
          <legend>Summary</legend>
          <div
            class="form-control"
            *ngIf="
              !isAdjustView &&
              !isCompleteAuthView &&
              !isRefundView &&
              view !== 'flashpay' &&
              view !== 'achpay' &&
              view !== 'onetimepay' &&
              isPreauthEnabledOnProfile()
            "
          >
            <mat-slide-toggle formControlName="enablePreauth" style="margin-right: 8px">Pre-Authorize</mat-slide-toggle>
          </div>
          <div class="form-control-group" *ngIf="!form.get('enablePreauth')?.value">
            <div class="form-control">
              <mat-form-field appearance="outline">
                <mat-label>Invoice Number</mat-label>
                <input formControlName="invoiceNumber" matInput />
                <mat-error ngx-mat-errors />
              </mat-form-field>
            </div>
            <div class="form-control"></div>
          </div>
          <div class="form-control-group">
            <div class="form-control">
              <mat-form-field appearance="outline" ngClass="currency">
                <mat-label>{{ invoiceTotalLabel }}</mat-label>
                <input formControlName="invoiceTotalAmount" matInput [currencyMask]="{ align: 'left' }" />
                <mat-error ngx-mat-errors />
              </mat-form-field>
            </div>
            <div class="form-control"></div>
          </div>
          <div class="form-control-group" *ngIf="enableShippingAmount">
            <div class="form-control">
              <mat-form-field appearance="outline" ngClass="currency">
                <mat-label>Shipping</mat-label>
                <input formControlName="shippingAmount" matInput [currencyMask]="{ align: 'left' }" />
                <mat-error ngx-mat-errors />
              </mat-form-field>
            </div>
            <div class="form-control">
              <mat-slide-toggle formControlName="enableShippingAmount"></mat-slide-toggle>
            </div>
          </div>
          <div class="form-control-group" *ngIf="enableTaxAmount">
            <div class="form-control">
              <mat-form-field appearance="outline" ngClass="currency">
                <mat-label>Tax</mat-label>
                <input formControlName="taxAmount" matInput [currencyMask]="{ align: 'left' }" />
                <mat-error ngx-mat-errors />
              </mat-form-field>
            </div>
            <div class="form-control">
              <mat-slide-toggle formControlName="enableTaxAmount"></mat-slide-toggle>
            </div>
          </div>
        </fieldset>
      </div>
      <div class="col-4">
        <fieldset>
          <legend>Add Ons</legend>

          <div
            *ngIf="!isAchPaymentContext && cocBlockedState"
            class="form-control-group"
            style="align-items: center; gap: 6px; color: #666; font-size: 0.85rem; padding: 4px 0"
          >
            <mat-icon style="font-size: 16px; height: 16px; width: 16px; color: #999">info_outline</mat-icon>
            <span>Cost of capital is not applicable for cards billed in {{ cocBlockedState }}.</span>
          </div>

          <div
            class="form-control-group"
            style="flex-direction: column; justify-content: stretch"
            *ngIf="!isAchPaymentContext && enableCostOfCapital"
          >
            <div class="form-control-group" style="flex-wrap: nowrap; margin-bottom: 0">
              <div class="form-control">
                <mat-form-field appearance="outline" ngClass="currency">
                  <mat-label>{{ capitalCostLabel }}</mat-label>
                  <span *ngIf="cardLabelInfo !== ''">{{ cardLabelInfo }}</span>
                  <input formControlName="capitalAmount" matInput [currencyMask]="{ align: 'left' }" />
                  <mat-button-toggle-group
                    formControlName="capPreSelect"
                    class="page-payment-collect__tabs"
                    *ngIf="enableCapPreSelect && !isFreelyCard"
                  >
                    <mat-button-toggle value="cap_2"><span>2%</span></mat-button-toggle>
                    <mat-button-toggle value="cap_3">3%</mat-button-toggle>
                    <mat-button-toggle value="cap_other">Other</mat-button-toggle>
                  </mat-button-toggle-group>
                  <mat-button-toggle-group
                    formControlName="capPreSelect"
                    class="page-payment-collect__tabs page-payment-collect__tabs--freely"
                    *ngIf="enableCapPreSelect && isFreelyCard"
                  >
                    <mat-button-toggle value="cap_1">
                      <span>{{ freelyCardLabel }} {{ freelyCardPercent }}%</span>
                    </mat-button-toggle>
                  </mat-button-toggle-group>
                  <mat-error ngx-mat-errors />
                </mat-form-field>
              </div>
              <div class="form-control" style="margin-bottom: 0">
                <mat-slide-toggle formControlName="enableCapitalAmount"></mat-slide-toggle>
              </div>
            </div>

            <div class="form-control-group">
              <div class="form-control"></div>
            </div>
          </div>

          <!-- <div class="form-control-group">
          <div class="form-control">
            <mat-form-field appearance="outline" ngClass="currency">
              <mat-label>Other</mat-label>
              <input formControlName="otherAmount" matInput [currencyMask]="{align:'left'}">
              <mat-error ngx-mat-errors/>
            </mat-form-field>
          </div>
          <div class="form-control">
            <mat-slide-toggle formControlName="enableOtherAmount"></mat-slide-toggle>
          </div>
        </div> -->
        </fieldset>
      </div>
      <div class="col-4">
        <fieldset>
          <legend>Total</legend>
          @if (isCompleteAuthView) {
          <div>Pre-Authorization Amount: {{ preauthorizationAmount || '0.00' | currency }}</div>
          <br />
          } @if (isRefundView) {
          <table class="app-invoice-details__form-totals">
            <tr>
              <td>{{ refundAmount || '0.00' | currency }}</td>
              <td>........</td>
              <td>Original Payment Amount</td>
            </tr>
            @if (previousRefundAmount > 0) {
            <tr>
              <td colspan="3">-</td>
            </tr>
            <tr>
              <td>{{ previousRefundAmount | currency }}</td>
              <td>........</td>
              <td>Previous Refund Amount</td>
            </tr>
            <tr>
              <td colspan="3">=</td>
            </tr>
            <tr>
              <td>
                <strong>{{ availableRefundAmount || '0.00' | currency }}</strong>
              </td>
              <td>........</td>
              <td><strong>Available to Refund Amount</strong></td>
            </tr>
            }
          </table>
          <br />
          } @if (isAdjustView) {
          <div>Original Payment Amount: {{ adjustAmount || '0.00' | currency }}</div>
          <br />
          }
          <table class="app-invoice-details__form-totals">
            <!-- Subtotal -->
            <tr>
              <td>{{ form.controls.subtotalAmount.value | currency }}</td>
              <td>........</td>
              <td>Subtotal</td>
            </tr>

            <!-- Shipping -->
            @if (form.controls.shippingAmount.getRawValue() && this.Number(form.controls.shippingAmount.getRawValue()) >
            0) {
            <tr>
              <td colspan="3">+</td>
            </tr>
            <tr>
              <td>{{ form.controls.shippingAmount.getRawValue() | currency }}</td>
              <td>........</td>
              <td>Shipping</td>
            </tr>
            }

            <!-- Tax -->
            @if (form.controls.taxAmount.getRawValue() && this.Number(form.controls.taxAmount.getRawValue()) > 0) {
            <tr>
              <td colspan="3">+</td>
            </tr>
            <tr>
              <td>{{ form.controls.taxAmount.getRawValue() | currency }}</td>
              <td>........</td>
              <td>Tax</td>
            </tr>
            }

            <!-- Invoice -->
            <tr>
              <td colspan="3">=</td>
            </tr>
            <tr>
              <td>
                <strong>{{ form.controls.invoiceTotalAmount.value | currency }}</strong>
              </td>
              <td>........</td>
              <td>
                <strong>{{ totals[0].title }}</strong>
              </td>
            </tr>

            <!-- Capital -->
            @if (form.controls.capitalAmount.getRawValue() && this.Number(form.controls.capitalAmount.getRawValue()) >
            0) {
            <tr>
              <td colspan="3">+</td>
            </tr>
            <tr>
              <td>{{ form.controls.capitalAmount.getRawValue() | currency }}</td>
              <td>........</td>
              <td>Capital Costs</td>
            </tr>
            }

            <!-- Other -->
            @if (form.controls.otherAmount.getRawValue() && this.Number(form.controls.otherAmount.getRawValue()) > 0) {
            <tr>
              <td colspan="3">+</td>
            </tr>
            <tr>
              <td>{{ form.controls.otherAmount.getRawValue() | currency }}</td>
              <td>........</td>
              <td>Other</td>
            </tr>
            }

            <!-- Payment Total -->
            <tr>
              <td colspan="3">=</td>
            </tr>
          </table>
          <div class="form-control-group">
            <div class="form-control">
              <mat-form-field appearance="outline" ngClass="currency">
                <mat-label>{{ getTotalAmountLabel() }}</mat-label>
                <input readonly formControlName="totalAmount" matInput [currencyMask]="{ align: 'left' }" />
                <mat-error ngx-mat-errors />
              </mat-form-field>
            </div>
            <div class="form-control"></div>
          </div>
        </fieldset>
      </div>
    </div>
  </div>

  <!-- Multi-Invoice Selection -->
  <div class="multi-invoice-form" *ngIf="isMultiInvoiceMode">
    <app-multi-invoice-selection
      [customerId]="selectedCustomer?.id"
      [preSelectedInvoiceId]="preSelectedInvoiceId"
      [paymentMode]="paymentForm.value?.paymentMode ?? undefined"
      [cardFunding]="paymentForm.value?.paymentMethod?.cardFunding ?? undefined"
      [isCreditCard]="paymentForm.value?.paymentMethod?.isCreditCard ?? undefined"
      [isDebitCard]="paymentForm.value?.paymentMethod?.isDebitCard ?? undefined"
      [cardType]="paymentForm.value?.paymentMethod?.cardType ?? undefined"
      [cardZip]="paymentForm.value?.paymentMethod?.zipCode ?? undefined"
      [sendMode]="isAdvancedFlashPayView"
      [ngModel]="multiInvoiceData"
      (ngModelChange)="onMultiInvoiceDataChange($event)"
    >
    </app-multi-invoice-selection>
  </div>
</div>
